import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import dayjs from "dayjs";
import BrianyCareLogo from "../../assets/auth/BrainyCare-Logo.jpg";
import DrMadhuSign from "../../assets/imaging/madhusign.png";
import { allowedUsers } from '../allowedUsers';
import axios from "axios";

const CarotidView = () => {
  const { filename } = useParams();
  const [examData, setExamData] = useState(null);

  // Fetch data from API
  const fetchData = async () => {
    try {
      const response = await axios.post(
        `/v2/ag/v1/${window.getPracticeId()}/imaging/get-image/id`,
        { row_id: parseInt(filename, 10) }
      );

      if (response?.data?.data[0]) {
        const raw = response.data?.data[0];
        const parsedData = JSON.parse(raw.data);
        console.log("CAROTID ", parsedData);
        setExamData(parsedData);
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  useEffect(() => {
    if (filename) fetchData();
  }, [filename]);
  
  return (
    <div id={examData ? "report-ready" : undefined} className="p-6 bg-white min-h-screen w-full flex justify-center items-center">
      <div className="w-full max-w-4xl flex flex-col border border-gray-300 rounded-md p-8 shadow-sm bg-white">
        {/* Header */}
<div className="flex items-center w-full justify-center">
  {/* Logo */}
  <img
    src={BrianyCareLogo}
    alt="Center for Hypertension & Internal Medicine"
    className="w-16 h-16 mr-4 flex-shrink-0"
  />

  {/* Text Content */}
  <div className="text-left">
    <h1 className="text-[1.5rem] font-semibold leading-tight">
      CENTER FOR HYPERTENSION <br/>& INTERNAL MEDICINE
    </h1>
  </div>
</div>
  <div className="text-center mb-6">
    <p className="text-sm font-medium mt-1">807 N Hancock Ave, Odessa, TX 79761</p>
    <p className="text-sm font-medium mt-1">Ph: 432-582-2446 &nbsp;|&nbsp; Fax: 432-582-2960</p>
  </div>


        {/* Title */}
        <h2 className="text-center font-bold text-base mb-4">CAROTID</h2>

        {examData ? (
          <>
            {/* Render Patient Info */}
            <div className="flex justify-start text-sm text-left w-full mb-4">
              <div className="grid grid-cols-[auto_20px_1fr] gap-x-2 gap-y-1">
                <span><strong>MR No#</strong></span><span>:</span><span>{examData.patient_id}</span>
                <span><strong>Name</strong></span><span>:</span><span>{examData.pat_name}</span>
                <span><strong>Age</strong></span><span>:</span><span>{examData.pat_age}</span>
                <span><strong>Exam Date</strong></span><span>:</span><span>{dayjs(examData.examDate).format("MM, DD, YYYY")}</span>
                <span><strong>Date of Birth</strong></span><span>:</span><span>
                  {dayjs(examData.pat_dob).format("MMM D, YYYY")}
                </span>
              </div>
            </div>

            {/* Form data view */}
            <div className="w-full text-start mb-6 text-sm">
              <div className="grid grid-cols-2">
                <div className="mt-2"><strong>Take:</strong> {examData.take || ''}</div>
                <div className="mt-2"><strong>Tape:</strong> {examData.tape || ''}</div>
              </div>
              <div className="grid grid-cols-2">
                <div className="mt-2"><strong>Requested by:</strong> {examData.requestedby || ''}</div>
                <div className="mt-2"><strong>Technician:</strong> {examData.technician || ''}</div>
              </div>
            </div>



  {/* History */}
      <div className="mt-1">
        <h6 className="text-xl font-semibold mb-2 text-start"> History</h6>
          <div className="grid grid-cols-1 mb-3 text-start">
            {examData.pathistory.map((hist, index) => (
              <p key={index} className="block">
                {hist.value || ''}
              </p>
            ))}
          </div>
      </div>


    <div className="py-1 mt-3">
      {/* BP R Section */}
      <div className="grid grid-cols-2 gap-6 mb-2">
        <div className="border p-3">
          <h6 className="text-xl font-semibold mb-2  text-start">BP R</h6>
          <div className="space-y-4 text-start">
            <div>
              {examData.BPR.bpr}
            </div>
            <div className="bg-gray-300 text-black p-1  text-start"> :: R PSV/EDV</div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">DISTAL ICA </label>
                {examData.BPR.distalica}
            </div>
            
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX ICA </label>
                {examData.BPR.proxica}
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX ECA </label>
                {examData.BPR.proxeca}
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX CCA </label>
                {examData.BPR.proxcca}
            </div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">ICA/CCA RATIO</label>
                {examData.BPR.icaccaratio}
            </div>

          </div>
        </div>

        {/* BP L Section */}
        <div className="border p-3">
          <h6 className="text-xl font-semibold mb-2 text-start">BP L</h6>
          <div className="space-y-4 text-start">
            <div>
              {examData.BPL.bpl}
            </div>
            <div className="bg-gray-300 text-black p-1 text-start"> :: L PSV/EDV</div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">DISTAL ICA </label>
                {examData.BPL.distalica}              
            </div>
            
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX ICA </label>
                {examData.BPL.proxica}
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX ECA </label>
                {examData.BPL.proxeca}
            </div>

            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">PROX CCA </label>
                {examData.BPL.proxcca}
            </div>
            <div className="flex items-center gap-2">
                <label className="text-sm  mt-2 text-center font-medium text-gray-700">ICA/CCA RATIO</label>
                {examData.BPL.icaccaratio}
            </div>

          </div>
        </div>

      </div>
      </div>

          


  {/* Technician's Comments Section */}
<div className="py-8">
  <h2 className="text-xl font-semibold text-start">
    {allowedUsers.includes(examData?.createdby) ? (
      <div>IMPRESSIONS</div>
    ) : (
      <div>TECHNICIAN COMMENTS</div>
    )}
    </h2>
  <div className="grid gap-6 mb-8">
    <div className="space-y-4 text-start">
      {examData.technicianComments.map((comment) => (
        <div key={comment.id}>
          {comment.id === 3 || comment.id === 4 || comment.id === 5 ? (
            // If it's one of the specific id's (3, 4, 5), display dropdown and text value
            <div className="grid grid-cols-2 gap-2 py-2">
              {/* <div>{comment.dropdown || "-"}</div> */} {/* Dropdown on the left */}
              <div>{comment.text}</div>     {/* Text on the right */}
            </div>
          ) : (
            // For other comments, display the generic comment value
            <div className="text-start">
              {/* Display label if available */}
              {/* {comment.label && (
                <label className="block text-sm font-medium text-gray-700">{comment.label}</label>
              )} */}
              {/* Render the value or fallback to a string representation */}
              <div className="mt-1 text-sm">{comment.value}</div>
            </div>
          )}
        </div>
      ))}
    </div>
  </div>
</div>

        {examData ? (
                  <>
            <div className="py-8">
              <div className="flex justify-between items-center">
                <div>
                    {examData?.signoff && (
                      <>
                        <img src={DrMadhuSign} alt="Signed Off" className="ml-2 h-20 inline-block" />
                        <div className="font-semibold">Dr. Madhu Pamganamamula MD FACP FASPC DABOM DABCL CCD</div>
                      </>
                    )}
                </div>
              </div>
            </div>
        </>
        ) : (
         <></>
        )}

          </>
        ) : (
          <p className="text-center text-gray-500">Loading...</p>
        )}
      </div>
    </div>
  );
};

export default CarotidView;